module.exports = __webpack_public_path__ + "static/Stefano-Perregrini-2e657515c5320a5ed27b0940bcdf5b41.jpg";